import type { RouteRecordRaw } from 'vue-router'

// Account settings now live under the unified Settings (/settings/*).
// Keep the old path as a tab-aware redirect so bookmarks & deep links still work.
export const accountSettingsRoutes: RouteRecordRaw[] = [
  {
    path: '/pages/account-settings',
    redirect: (to) => {
      const tab = String(to.query.tab || '')
      if (tab === 'Security') return '/settings/security'
      return '/settings/account'
    }
  }
]
